export default "__VITE_ASSET__nmt0$lXP__"